import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    n: "۰۱",
    title: "ثبت درخواست",
    text: "فرم همکاری را تکمیل می‌کنید و اطلاعات اولیه اثر، نام هنری، لینک شبکه‌های اجتماعی و نوع درخواست خود را ارسال می‌کنید.",
  },
  {
    n: "۰۲",
    title: "بررسی اثر و اطلاعات",
    text: "تیم ما فایل صوتی، کاور، اطلاعات هنرمند، مالکیت اثر و شرایط انتشار را بررسی می‌کند.",
  },
  {
    n: "۰۳",
    title: "انتشار در پلتفرم‌ها",
    text: "پس از تایید نهایی، موزیک یا موزیک‌ویدیو شما برای انتشار در پلتفرم‌های بین‌المللی ثبت می‌شود.",
  },
  {
    n: "۰۴",
    title: "گزارش و تسویه درآمد",
    text: "درآمد ایجادشده از پلتفرم‌ها جمع‌آوری می‌شود و پس از کسر کارمزد، سهم شما در ایران تسویه می‌شود.",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            روند انتشار موزیک <span className="gradient-text">چطور</span> انجام می‌شود؟
          </h2>
        </div>

        <div className="mt-14 relative">
          {/* timeline line */}
          <div className="hidden md:block absolute top-9 right-[6%] left-[6%] h-px bg-gradient-to-l from-purple-500/40 via-cyan-400/40 to-purple-500/40" />

          <div className="grid md:grid-cols-4 gap-6 relative">
            {STEPS.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative"
                data-testid={`step-${i + 1}`}
              >
                <div className="flex justify-center">
                  <div className="relative w-16 h-16 rounded-full glass flex items-center justify-center font-extrabold text-lg gradient-text-neon glow-purple z-10">
                    {s.n}
                  </div>
                </div>
                <div className="mt-6 glass glass-hover rounded-3xl p-6 text-center transition">
                  <h3 className="text-lg font-bold mb-2">{s.title}</h3>
                  <p className="text-sm text-slate-300 leading-relaxed">{s.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
